import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';

import { PageHeader } from '../../../../components/PageHeader';
import { Loader } from '../../../../components/Loader';
import { CompanyInformation } from './components/CompanyInformation';
import { AnalysisPlots } from './components/AnalysisPlots';
import { ErrorList } from './components/ErrorList';
import { ExportAnalysisButton } from './components/ExportAnalysisButton';

import { useCompanyAnalyticsData } from './useCompanyAnalyticsData';

import { MyCompanyAnalyticsContainer } from './style';

export const MyCompanyAnalytics = () => {
  const navigate = useNavigate();
  const { companyAnalyticsData, loading } = useCompanyAnalyticsData();

  return (
    <>
      <PageHeader
        titleTranslationKey='myCompanies.analyticsMyCompanyTitle'
        onBack={() => navigate('/front/my-companies')}
        extra={<ExportAnalysisButton companyData={companyAnalyticsData?.company} />}
      />
      <Loader loading={loading}>
        {companyAnalyticsData ? (
          <MyCompanyAnalyticsContainer>
            <CompanyInformation companyData={companyAnalyticsData.company} />
            <AnalysisPlots data={companyAnalyticsData.data} company={companyAnalyticsData.company} />
            <ErrorList errors={companyAnalyticsData.wcoxml} />
          </MyCompanyAnalyticsContainer>
        ) : (
          <Empty />
        )}
      </Loader>
    </>
  );
};
